import React from 'react';
import PropTypes from 'prop-types';
import PositionSummary from "./PositionSummary";

const AssignCandidateModal = ({candidate,position, onConfirm}) => {

    const forTeam = !position;
    const isFixedFee = candidate.isFixedFee();
    const isFixedRetainer = candidate.isFixedRetainer();
    return (
        <div className="assign-candidate-container">
            <p className="assign-candidate-header">
                {forTeam ? 'Please review and confirm the team\'s proposal and estimated cost' :
                    (isFixedFee ? "Please review and confirm the candidate’s proposed project price" :
                        (isFixedRetainer ? 'Please review and confirm the candidate\'s retainer and estimated fees summarized below.' :
                                'Please review and confirm the candidate\'s rate and estimated fees summarized below.'
                        ))}
            </p>
            {!forTeam && candidate.hasRequestedChangesToAvailability(position) && (
                <p className="assign-candidate-note alert-danger px-4 py-2 my-2">
                    <i className="fas fa-info-circle mr-3"/>

                    {(isFixedRetainer || isFixedFee) ?
                        'Note: the candidates proposed price differs from the original estimate' :
                        'Note: the candidate\'s proposed start date, average hrs/week, or rate differs from the original estimate.'
                    }
                </p>
            )}

            <PositionSummary candidate={candidate} position={position}/>
            {/*<GanttChartPositions*/}
            {/*    project={proposedProject}*/}
            {/*    editable={false}*/}
            {/*    showCost={true}*/}
            {/*/>*/}

            <div className="assign-candidate-actions">
                <button className="btn btn-outline-dark" onClick={() => TB.event("Modal@hide")}>
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={async() => {
                    await TB.event("Modal@hide");
                    onConfirm()
                }}>
                    Accept & Continue
                </button>
            </div>
        </div>
    );
};

AssignCandidateModal.propTypes = {
    position: PropTypes.object,
    candidate: PropTypes.object,
    onConfirm: PropTypes.func
};

export default AssignCandidateModal;